var _excluded = ["icon", "iconPosition", "iconProps", "inputProps", "focusProps", "animatedPlaceholderProps", "animatedInputProps", "placeholder", "shiftPlaceholderOnFocus", "variant", "value", "onChange", "animated", "extraIcons", "extraInputs"],
    _excluded2 = ["iconProps", "inputProps", "focusProps", "animatedPlaceholderProps", "animatedPlaceholderFocusProps", "animatedInputProps", "animatedInputFocusProps"],
    _excluded3 = ["inputProps", "iconProps", "animatedPlaceholderProps", "animatedInputProps"],
    _excluded4 = ["iconProps", "inputProps", "animatedPlaceholderProps", "animatedInputProps", "focusProps"],
    _excluded5 = ["position", "hideOnAnimateInitialState"],
    _excluded6 = ["position", "hideOnAnimateInitialState"],
    _excluded7 = ["position", "icon"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.object.assign.js";

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { styled, useVariantProps } from '@pyt/core/native';
import { cloneElement } from 'react';
import { useState, useEffect } from 'react';
import { useMemo } from 'react';
import { forwardRef } from 'react';
import { TextInput } from 'react-native';
import { useCombinedRef, useDevice, useDidUpdate } from '@pyt/hooks';
import { Text } from '../text/index';
import { animated, useSpring } from '@react-spring/native';
var View = styled('View', {
  flexDirection: 'row',
  alignItems: 'center',
  cursor: 'default'
}, 'input');
var StyledInput = styled(animated(TextInput), {
  width: '100%',
  outlineWidth: 0,
  outlineStyle: 'none'
});
var AnimatedPlaceholer = styled(animated(Text), {
  position: 'absolute',
  zIndex: -1
});

var renderIcon = (icon, props) => {
  if (!icon) {
    return null;
  }

  return typeof icon === 'function' ? icon(props) : cloneElement(icon, props);
};

var Component = (_ref, propRef) => {
  var _propInputProps$defau;

  var {
    icon,
    iconPosition = 'left',
    iconProps: propIconProps = {},
    inputProps: propInputProps = {},
    focusProps: propFocusProps = {},
    animatedPlaceholderProps: propAnimatedPlaceholderProps = {},
    animatedInputProps: propAnimatedInputProps = {},
    placeholder,
    shiftPlaceholderOnFocus = true,
    variant = 'default',
    value,
    onChange,
    animated,
    extraIcons = [],
    extraInputs = []
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var variantProps = useVariantProps(variant, 'input');
  var {
    platform
  } = useDevice();
  var [focus, setFocus] = useState(false);
  var [animatedPlaceholderStyle, placeholderApi] = useSpring(() => ({}));
  var [animatedInputStyle, inputApi] = useSpring(() => ({}));
  var [hideExtraInputStyle, extraInputApi] = useSpring(() => ({
    opacity: 0
  }));
  var [inputValue, setInputValue] = useState(value);
  var [shiftPlaceholder, setShiftPlaceholder] = useState(!!(value !== null && value !== void 0 && value.length) || !!extraInputs.filter(_ref2 => {
    var {
      value
    } = _ref2;
    return !!(value !== null && value !== void 0 && value.length);
  }).length || !!(propInputProps !== null && propInputProps !== void 0 && (_propInputProps$defau = propInputProps.defaultValue) !== null && _propInputProps$defau !== void 0 && _propInputProps$defau.length));

  var _useMemo = useMemo(() => {
    var {
      iconProps,
      inputProps,
      animatedPlaceholderProps,
      animatedInputProps,
      focusProps: {
        inputProps: focusInputProps = {},
        iconProps: focusIconProps = {},
        animatedPlaceholderProps: focusAnimatedPlaceholderProps = {},
        animatedInputProps: focusAnimatedInputProps = {}
      } = {}
    } = variantProps,
        restFocusProps = _objectWithoutProperties(variantProps.focusProps, _excluded3),
        restVariantProps = _objectWithoutProperties(variantProps, _excluded4);

    var {
      inputProps: propInputFocusProps = {},
      iconProps: propIconFocusProps = {},
      animatedPlaceholderProps: propAnimatedPlaceholderFocusProps = {},
      animatedInputProps: propAnimatedInputFocusProps = {}
    } = propFocusProps;
    return _objectSpread({
      iconProps: _objectSpread(_objectSpread(_objectSpread({}, iconProps), propIconProps), focus ? _objectSpread(_objectSpread({}, focusIconProps), propIconFocusProps) : {}),
      inputProps: _objectSpread(_objectSpread(_objectSpread({}, inputProps), propInputProps), focus ? _objectSpread(_objectSpread({}, focusInputProps), propInputFocusProps) : {}),
      animatedPlaceholderProps: _objectSpread(_objectSpread(_objectSpread({}, animatedPlaceholderProps), propAnimatedPlaceholderProps), shiftPlaceholder ? _objectSpread(_objectSpread({}, focusAnimatedPlaceholderProps), propAnimatedPlaceholderFocusProps) : {}),
      animatedPlaceholderFocusProps: _objectSpread(_objectSpread({}, focusAnimatedPlaceholderProps), propAnimatedPlaceholderFocusProps),
      animatedInputProps: _objectSpread(_objectSpread(_objectSpread({}, animatedInputProps), propAnimatedInputProps), shiftPlaceholder ? _objectSpread(_objectSpread({}, focusAnimatedInputProps), propAnimatedInputFocusProps) : {}),
      animatedInputFocusProps: _objectSpread(_objectSpread({}, focusAnimatedInputProps), propAnimatedInputFocusProps),
      focusProps: focus ? _objectSpread(_objectSpread({}, restFocusProps), propFocusProps) : {}
    }, _objectSpread(_objectSpread({}, restVariantProps), props));
  }, [propIconProps, propInputProps, propAnimatedPlaceholderProps, propFocusProps, variantProps, focus, shiftPlaceholder]),
      {
    iconProps,
    inputProps,
    focusProps,
    animatedPlaceholderProps,
    animatedPlaceholderFocusProps,
    animatedInputProps,
    animatedInputFocusProps
  } = _useMemo,
      restProps = _objectWithoutProperties(_useMemo, _excluded2);

  useEffect(() => {
    if (shiftPlaceholder) {
      placeholderApi.start({
        to: animatedPlaceholderFocusProps,
        config: {
          duration: 200
        }
      });
      inputApi.start({
        to: animatedInputFocusProps
      });
      extraInputApi.start({
        to: {
          opacity: 1
        }
      });
    } else {
      placeholderApi.start({
        to: animatedPlaceholderProps,
        config: {
          duration: 200
        }
      });
      inputApi.start({
        to: animatedInputProps
      });
      extraInputApi.start({
        to: {
          opacity: 0
        }
      });
    }
  }, [shiftPlaceholder]);
  var ref = useCombinedRef(propRef);
  useDidUpdate(() => {
    var _propInputProps$defau2;

    setInputValue(value);

    if (!!(value !== null && value !== void 0 && value.length) || !!extraInputs.filter(_ref3 => {
      var {
        value
      } = _ref3;
      return !!(value !== null && value !== void 0 && value.length);
    }).length || !!(propInputProps !== null && propInputProps !== void 0 && (_propInputProps$defau2 = propInputProps.defaultValue) !== null && _propInputProps$defau2 !== void 0 && _propInputProps$defau2.length)) {
      setShiftPlaceholder(true);
    }
  }, [value]);
  return React.createElement(View, _extends({}, restProps, focusProps, inputProps.numberOfLines ? {
    height: 'auto'
  } : {}), iconPosition === 'left' ? renderIcon(icon, iconProps) : null, extraInputs.filter(_ref4 => {
    var {
      position
    } = _ref4;
    return position === 'left';
  }).map(_ref5 => {
    var {
      position,
      hideOnAnimateInitialState
    } = _ref5,
        inputProps = _objectWithoutProperties(_ref5, _excluded5);

    return React.createElement(StyledInput, _extends({}, inputProps, animated ? _objectSpread({
      style: hideOnAnimateInitialState ? hideExtraInputStyle : animatedInputFocusProps
    }, animatedInputProps) : {}, {
      onFocus: e => {
        setFocus(true);

        if (shiftPlaceholderOnFocus) {
          setShiftPlaceholder(true);
        }
      },
      onBlur: e => {
        var _propInputProps$defau3;

        setFocus(false);

        if (!(inputValue !== null && inputValue !== void 0 && inputValue.length) && !extraInputs.filter(_ref6 => {
          var {
            value
          } = _ref6;
          return !!(value !== null && value !== void 0 && value.length);
        }).length && !(propInputProps !== null && propInputProps !== void 0 && (_propInputProps$defau3 = propInputProps.defaultValue) !== null && _propInputProps$defau3 !== void 0 && _propInputProps$defau3.length)) {
          setShiftPlaceholder(false);
        }
      }
    }));
  }), React.createElement(StyledInput, _extends({
    marginLeft: icon && iconPosition === 'left' ? 8 : undefined,
    marginRight: icon && iconPosition === 'right' ? 8 : undefined
  }, inputProps, {
    placeholder: !animated ? placeholder : null,
    onFocus: e => {
      var _inputProps$onFocus;

      setFocus(true);
      inputProps === null || inputProps === void 0 ? void 0 : (_inputProps$onFocus = inputProps.onFocus) === null || _inputProps$onFocus === void 0 ? void 0 : _inputProps$onFocus.call(inputProps, e);

      if (shiftPlaceholderOnFocus) {
        setShiftPlaceholder(true);
      }
    },
    onBlur: e => {
      var _inputProps$onBlur, _propInputProps$defau4;

      setFocus(false);
      inputProps === null || inputProps === void 0 ? void 0 : (_inputProps$onBlur = inputProps.onBlur) === null || _inputProps$onBlur === void 0 ? void 0 : _inputProps$onBlur.call(inputProps, e);

      if (!(inputValue !== null && inputValue !== void 0 && inputValue.length) && !extraInputs.filter(_ref7 => {
        var {
          value
        } = _ref7;
        return !!(value !== null && value !== void 0 && value.length);
      }).length && !(propInputProps !== null && propInputProps !== void 0 && (_propInputProps$defau4 = propInputProps.defaultValue) !== null && _propInputProps$defau4 !== void 0 && _propInputProps$defau4.length)) {
        setShiftPlaceholder(false);
      }
    }
  }, animated ? _objectSpread({
    style: animatedInputStyle
  }, animatedInputProps) : {}, {
    value: value,
    onChangeText: text => {
      onChange === null || onChange === void 0 ? void 0 : onChange(text);
      setInputValue(text);
    },
    ref: ref
  })), extraInputs.filter(_ref8 => {
    var {
      position
    } = _ref8;
    return position === 'right';
  }).map(_ref9 => {
    var {
      position,
      hideOnAnimateInitialState
    } = _ref9,
        inputProps = _objectWithoutProperties(_ref9, _excluded6);

    return React.createElement(StyledInput, _extends({}, inputProps, animated ? _objectSpread({
      style: hideOnAnimateInitialState ? hideExtraInputStyle : animatedInputStyle
    }, animatedInputProps) : {}, {
      onFocus: e => {
        setFocus(true);

        if (shiftPlaceholderOnFocus) {
          setShiftPlaceholder(true);
        }
      },
      onBlur: e => {
        var _propInputProps$defau5;

        setFocus(false);

        if (!(inputValue !== null && inputValue !== void 0 && inputValue.length) && !extraInputs.filter(_ref10 => {
          var {
            value
          } = _ref10;
          return !!(value !== null && value !== void 0 && value.length);
        }).length && !(propInputProps !== null && propInputProps !== void 0 && (_propInputProps$defau5 = propInputProps.defaultValue) !== null && _propInputProps$defau5 !== void 0 && _propInputProps$defau5.length)) {
          setShiftPlaceholder(false);
        }
      }
    }));
  }), animated ? React.createElement(AnimatedPlaceholer, _extends({
    style: animatedPlaceholderStyle
  }, animatedPlaceholderProps), placeholder) : null, iconPosition === 'right' ? renderIcon(icon, _objectSpread(_objectSpread({
    cursor: 'pointer'
  }, iconProps), {}, {
    [platform === 'web' ? 'onClick' : 'onPress']: () => {
      if (typeof ref !== 'function') {
        var _ref$current;

        ref === null || ref === void 0 ? void 0 : (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.focus();
      }
    }
  })) : null, extraIcons.filter(_ref11 => {
    var {
      position
    } = _ref11;
    return position === 'right';
  }).map(_ref12 => {
    var {
      position,
      icon
    } = _ref12,
        iconProps = _objectWithoutProperties(_ref12, _excluded7);

    return renderIcon(icon, _objectSpread(_objectSpread({
      cursor: 'pointer'
    }, iconProps), {}, {
      [platform === 'web' ? 'onClick' : 'onPress']: () => {
        console.log('rpops in', iconProps);

        if (typeof ref !== 'function') {
          var _ref$current2;

          ref === null || ref === void 0 ? void 0 : (_ref$current2 = ref.current) === null || _ref$current2 === void 0 ? void 0 : _ref$current2.focus();
        }
      }
    }));
  }));
};

export var Input = forwardRef(Component);